(() => {
  const CONFIG = window.GS_THEME_EXPERIMENT_CONFIG || {};
  const ATTRIBUTES = Object.freeze({
    __gs_experiment_id: String(CONFIG.experimentId || '').trim(),
    __gs_experiment_arm: String(CONFIG.experimentArm || '').trim(),
    __gs_website_version: String(CONFIG.websiteVersion || '').trim(),
  });
  const STORAGE_KEY = `gs:order-attribution:${ATTRIBUTES.__gs_experiment_id}:${ATTRIBUTES.__gs_experiment_arm}:${ATTRIBUTES.__gs_website_version}`;

  if (!window.__gsThemeOrderAttributionLoaded) {
    window.__gsThemeOrderAttributionLoaded = true;

    let markPromise;

    function hasCompleteConfig() {
      return Object.values(ATTRIBUTES).every(Boolean);
    }

    function readStorage() {
      try {
        return window.sessionStorage.getItem(STORAGE_KEY);
      } catch {
        return null;
      }
    }

    function writeStorage() {
      try {
        window.sessionStorage.setItem(STORAGE_KEY, '1');
      } catch {
        // Cart attribution still works when storage is unavailable.
      }
    }

    function dispatchResult(result) {
      document.documentElement.dataset.gsOrderAttribution = result;
      window.dispatchEvent(
        new CustomEvent('gs:cart-attribution', {
          detail: {
            result,
            experimentId: ATTRIBUTES.__gs_experiment_id,
            experimentArm: ATTRIBUTES.__gs_experiment_arm,
            websiteVersion: ATTRIBUTES.__gs_website_version,
          },
        })
      );
    }

    function cartUpdateUrl() {
      const root = window.Shopify?.routes?.root || '/';
      return `${root}cart/update.js`;
    }

    function markCart({ force = false } = {}) {
      if (!hasCompleteConfig()) return Promise.resolve(false);
      if (!force && readStorage() === '1') return Promise.resolve(true);
      if (markPromise) return markPromise;

      markPromise = fetch(cartUpdateUrl(), {
        method: 'POST',
        credentials: 'same-origin',
        keepalive: true,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ attributes: ATTRIBUTES }),
      })
        .then((response) => {
          if (!response.ok) throw new Error(`Cart attribution failed: ${response.status}`);
          writeStorage();
          dispatchResult('success');
          return true;
        })
        .catch(() => {
          dispatchResult('failed');
          return false;
        })
        .finally(() => {
          markPromise = undefined;
        });

      return markPromise;
    }

    function handleCartLinesUpdate(event) {
      const action = event.action || event.detail?.action;
      const promise = event.promise || event.detail?.promise;
      if (action !== 'add' || !promise || typeof promise.then !== 'function') return;

      promise
        .then((result) => {
          if (result?.detail?.didError) return;
          markCart({ force: true });
        })
        .catch(() => {});
    }

    document.addEventListener('shopify:cart:lines-update', handleCartLinesUpdate, true);

    window.gsSavorOrderAttribution = Object.freeze({
      attributes: ATTRIBUTES,
      markCart,
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => markCart(), { once: true });
    } else {
      markCart();
    }
  }
})();
